module.exports = __webpack_public_path__ + "static/scale-model-of-hayward-japanese-gardens-in-hayward-california-8682d4199cdc77a59ff00c0c6875809d.png";